'use client';

import { BrandsTableModals } from '@/components/brands-table/BrandsTableModals';
import type { BrandsTableControllerValue } from '@/components/brands-table/use-brands-table-controller';
import { GroupTableView } from '@/components/group-tables/GroupTableView';

type BrandsTableViewProps = BrandsTableControllerValue;

export const BrandsTableView = ({ tableBindings, modalsBindings }: BrandsTableViewProps) => (
    <GroupTableView tableBindings={tableBindings} modals={<BrandsTableModals {...modalsBindings} />} />
);
